import { SchemeType } from 'types/user';

export const PPL_SCHEMES = [
  SchemeType.PayPerRegistration,
  SchemeType.PayPerVerifiedRegistration,
  SchemeType.PayPerFirstPurchase,
];

export const PAID_SCHEMES = [
  SchemeType.RevenueShare,
  SchemeType.PayPerRegistration,
  SchemeType.PayPerVerifiedRegistration,
  SchemeType.PayPerFirstPurchase,
  SchemeType.PpsRevenueShare,
];
